<template>
      <div class="flight">
        <div class="destination">
          {{ flight.destination.city }}
          <div class="toggles">
            <div class="more-3" v-on:click="flight.details = !flight.details">
              <i v-if="flight.details" class="fa fa-toggle-on"></i>
              <i v-if="!flight.details" class="fa fa-toggle-off"></i>
              <div class="label-2">Show More Flight Details</div>
            </div>

              <div class="more-3" v-on:click="flight.attractions = !flight.attractions">
                <i v-if="flight.attractions" class="fa fa-toggle-on"></i>
                <i v-if="!flight.attractions" class="fa fa-toggle-off"></i>
              <div class="label-2">Show Destination Attractions</div>
            </div>
          </div>
        </div>

        <div class="details">

          <div class="length">
            <div class="label">Length</div>
            <div class="duration">{{ flight.trip.duration }} days</div>
            <div v-if="flight.details" class="label">Round trip</div>
          </div>

          <div class="leave">
            <div class="label">Leaving</div>
            <div class="date">{{ flight.trip.leave }}</div>
            <div v-if="flight.details" class="more-details">
              <div>
                {{flight.origin.airport}}
                <i class="fa fa-arrow-right"></i>
                {{flight.destination.airport}}
              </div>
              <div>
              Direct flight
              </div>
              <div>
                {{flight.airline}}
              </div>
            </div>
          </div>

          <div class="return">
            <div class="label">Returning</div>
            <div class="date">{{ flight.trip.return }}</div>
            <div v-if="flight.details" class="more-details">

              <div>
                {{flight.destination.airport}}
                <i class="fa fa-arrow-right"></i>
                {{flight.origin.airport}}
              </div>
              <div>
              Direct flight
              </div>
              <div>
                {{flight.airline}}
              </div>
            </div>
          </div>

          <div class="price">
            <!-- <div class="label">Price</div> -->
            <div class="data">${{ flight.price }}</div>
          </div>

          <div class="act">
            <a href="/#/book" class="book">
              <!-- <i class="fa fa-shopping-cart"></i> -->
              Get this ticket
            </a>
          </div>

        </div>

        <div v-if="flight.attractions" class="attractions">
          <ul>
              <li v-for="attraction in attractionsList">
                <div class="attraction">
                  <label>{{ attraction.name }}</label>
                  <img v-bind:src="attraction.img">
                  <p>{{ attraction.description }}</p>
                </div>
              </li>
          </ul>
        </div>
      </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'flight',
  props: ['flight'],
  // data: function () {
  //   return {
  //     attractions: false,
  //     details: false
  //   }
  // },
  computed: mapState({
    flights: state => state.flights,
    attractionsList (state) {
      console.log(state.ata[this.flight.destination.airport])
      return state.ata[this.flight.destination.airport].map(function (attraction) {
        return state.attractions[attraction]
      })
    }
  }),
  methods: {
    ...mapActions([
      'chooseFlight'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
li {
  display: inline-block;
  min-width: 160px;
  width: 100%;
}

.flight {
  margin: 3px;
  box-shadow: 1px 1px 1px #939393;
  background: white;
  /*cursor: pointer;*/
}

.destination {
  text-align: left;
  font-size: 16px;
  padding: 7px 11px 4px;
}
.details {
  display: flex;
  padding: 5px;
  padding-bottom: 10px;
  justify-content: space-between;
  line-height: 20px;
}
.leave,
.stay,
.return,
.price {
  /*display: inline-block;*/
  /*margin-left: 7px;*/
  /*margin-right: 7px;*/
  /*display: block;*/
}
.leave,
.return {
  /*width: 36%;*/
  margin-left: 9px;
  margin-right: 9px;
}
.length,
.price,
.act {
  /*width: 14%;*/
  margin-left: 9px;
  margin-right: 9px;
}
.length {
  width: 12%;
}
.leave,
.return {
  width: 29%
}
.price {
  width: 10%;
}
.act {
  width: 20%;
}
.label {
  /*border-bottom: 1px dotted #d2d2d2;*/
  font-size: 12px;
  /*display: inline-block;*/
}
.more-details {
  margin-top: 7px;
  font-size: 14px;
}
.more-details i {
  font-size: 10px;
}
/*.flight {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 5px;
  padding-right: 5px;
}
.flight i {
  font-size: 10px;
  color: #555;
  margin-left: 7px;
  margin-right: 7px;
}*/
.date,
.data {
  /*display: inline-block;*/
  font-size: 14px;
  /*text-align: left;*/
  /*padding-left: 5px;*/
  /*p
  .data {adding-right: 5px;*/
}
.data {
  font-size: 20px;
  padding-bottom: 14px;
}
.duration {
  font-size: 14px;
  /*display: inline-block;*/
}
.duration i {
  /*font-size: 18px;*/
}
.price {
  font-size: 22px;
  display: flex;
align-items: center;
}
.book {
  font-size: 14px;
  padding: 6px 13px;
  color: white;
  border-radius: 3px;
  background-color: #62c7dd;
  border: 1px solid #36b8d4;
  height: 100%;
  text-decoration: none;
}

.book:hover {
  box-shadow: 0px 0px 1px #848484;
  cursor: pointer;
}
.actions {
  display: flex;
justify-content: end;
margin-top: 7px;
border-top: 1px dotted #d2d2d2;
padding-top: 11px;
}
.book i {
  margin-right: 9px;
}
.location {
  font-size: 12px;

  padding: 3px 9px;
  color: white;
  border-radius: 3px;
  background-color: #25b5c6;
  border: 1px solid #149aaa;
  float: right;
  margin-right: 5px;
}
.more {
  /*background: #ececec;*/
  text-align: left;
padding: 3px;
  padding-left: 11px;
  /*border-top: 1px dotted #cbcbcb;*/
  color: #656565;
  flex-direction: column;
  align-items: center;
  display: flex;
  justify-content: center;
}

.more i {
  /*color: green;*/
}

.more .label {
  /*margin-left: 7px;*/
  /*display: inline-block;*/
}
.act {
  /*display: flex;*/
}

.more-2 {
  text-align: left;
  padding: 3px;
background: #ededed;
display: flex;
align-items: center;
justify-content: left;
}

.more-2 .label {
  padding-left: 9px;
  /*display: inline-block;*/
}

.more-3 {
  margin: 0 7px;
}
.more-3:hover {
  text-shadow: 1px 1px 1px #cbcbcb;
color: #0e8d9c;
cursor: pointer;
}
.label-2 {
  display: inline-block;
  font-size: 12px;
}
.more-3 i {
  font-size: 10px;
}
.toggles {
  display: flex;
}

.attractions {
  /*border-top: */
  /*padding: 5px 14px;*/
  display: flex;
  border-top: 1px dotted #e0e0e0;
  /*background-color: #e0e0e0;*/
}
.attractions ul {
  display: flex;
  width: 100%;
}
.attractions li {
  display: inline-block;
  width: 32%;
}
.attraction {
  margin: 7px;
}
.attraction label {
  display: block;
  text-align: left;
  font-size: 14px;
  margin: 3px;
}
.attraction p {
  margin: 3px;
  padding: 0;
  text-align: left;
  font-size: 12px;
}



/*.fa {
  font-size: 16px;
}
.origin,
.destination {
  width: 30%;
  display: inline-block;
}
.airport,
.leave {
  width: 50%;
  display: inline-block;
  text-align: center;
  font-size: 22px;
}
.leave {
  white-space: normal;
}
.duration {
  width: 20%;
  display: inline-block;
  text-align: center;
  font-size: 22px;
}
.price {
  width: 20%;
  display: inline-block;
}*/
</style>



// WEBPACK FOOTER //
// Flight.vue?df26bce0